// extracted by mini-css-extract-plugin
export default {"singleBondTemplate":"styles_singleBondTemplate__P1x6W","templateSubHeader500":"styles_templateSubHeader500__2V1bt","templateSubHeader300":"styles_templateSubHeader300__3jwT3"};